import React, { Component } from 'react';
import { Grid, TextField } from '@material-ui/core';
import style from './NewPatientPhotos.module.css';
import DragAndDrop from '../Photos/DragAndDrop';
import { Animated } from 'react-animated-css';
import DeleteOutlinedIcon from '@material-ui/icons/DeleteOutlined';
import { connect } from 'react-redux';
import { withLang } from '../../../util/lang';
import axios from '../../../axios-default';
import ModalLoader from '../../ModalLoader';
import { smileDesignProductListArray } from '../../../store/SmileDesign/SmileDesignSlice';
import {
    isValidTreatmentPlanUpload,
    TREATMENT_PLAN_UPLOAD_ACCEPT,
    allowedExtensions as TREATMENT_PLAN_ALLOWED_EXTENSIONS,
} from './TreatmentPlanUploadValidation';
class TreatmentPlan extends Component {
    constructor(props) {
        super(props);
        //set a default value for url of smile 3d
        this.props.treatmentPlan.smile_3d = '~pending upload~';
        this.handleInput('~pending upload~', 'smile_3d');
        this.handleInput(null, 'upper_cycle');
        this.handleInput(null, 'lower_cycle');
        this.handleInput(null, 'new_product');

        this.state = {
            loadingMyo: false,
        };
    }

    // fileToBase64 = file => new Promise((resolve, reject) => {
    //   const reader = new FileReader();
    //   if (file !== undefined) {
    //     reader.readAsDataURL(file);
    //   }
    //   reader.onload = () => resolve(reader.result);
    //   reader.onerror = error => reject(error);
    // });

    fileupload(file, stateType) {
        if (!isValidTreatmentPlanUpload(file, stateType)) {
            const errorMsg = this.get('treatmentPlan.fileTypeError').replace('{param1}', TREATMENT_PLAN_ALLOWED_EXTENSIONS[stateType].join('/'));
            alert(errorMsg);
            return;
        }
        let ClassThis = this;
        let fileName = file.name;
        ClassThis.props.handleTreatmentData(file, stateType, fileName);
        // let baseFile = this.fileToBase64(file).then((data) => {
        //   ClassThis.props.handleTreatmentData(data, stateType, fileName)
        // })
    }

    onFileChange = (event, stateType) => {
        const uploadedFile = event.target.files && event.target.files[0];
        if (uploadedFile) {
            this.fileupload(uploadedFile, stateType);
        }
        event.target.value = '';
    };

    onMyoFileChange = (event) => {
        this.handleMyo(event.target.files[0]);
    };

    handleMyo = async (uploadedFile) => {
        try {
            this.setState({ loadingMyo: true });
            if (!uploadedFile.name.includes('.myo') && !uploadedFile.name.includes('.myp')) {
                alert('Please upload a .myo/.myp file!');
                this.setState({ loadingMyo: false });
                return;
            }
            // Upload the .myo file and get the respond.
            const form = new FormData();
            let treatmentData = {
                case_id: this.props.patientInfo.id,
                patient_name: `${this.props.patientInfo.firstName} ${this.props.patientInfo.lastName}`,
            };
            let myoLink = `case/treatment_plan_myo/${this.props.patientInfo.id}`;
            let mypLink = `case/treatment_plan_myp/${this.props.patientInfo.id}`;

            let res;
            if (uploadedFile.name.includes('.myo')) {
                form.append('$$FILE:myo', uploadedFile);
                form.append('body', JSON.stringify(treatmentData));
                res = await axios.post(myoLink, form);
            } else {
                form.append('$$FILE:myp', uploadedFile);
                form.append('body', JSON.stringify(treatmentData));
                res = await axios.post(mypLink, form);
            }

            let smile3dUrl = res.data.url;
            this.props.treatmentPlan.smile_3d = smile3dUrl;
            this.props.treatmentPlan.myo_oid = res.data.oid;
            this.props.treatmentPlan.myo_pid = res.data.pid;
            this.props.treatmentPlan.myo_id = res.data.id;
            this.props.treatmentPlan.myo_token = res.data.token;
            this.handleInput(smile3dUrl, 'smile_3d');
            this.handleInput(res.data.upper_cycle, 'upper_cycle');
            this.handleInput(res.data.lower_cycle, 'lower_cycle');
            this.handleInput(res.data.new_product, 'new_product');
            this.setState({ loadingMyo: false });
        } catch (err) {
            this.setState({ loadingMyo: false });
            alert('Upload failed, please check your file and try again.');
            // if (window.confirm("Upload failed, please check your file and try again")){
            //   this.handleMyo(uploadedFile);
            // }
        }
    };

    handleDrop = (uploadedFile, stateType) => {
        this.fileupload(uploadedFile, stateType);
    };

    handleRadioButtonChange = (type) => {
        let smile3DElement = document.getElementById('Smile_3D_Grid');
        let smile3DTextField = document.getElementById('3durl');
        let myoElement = document.getElementById('myo_grid');
        switch (type) {
            case 'select_url':
                // smile3DElement.hidden = false
                smile3DTextField.disabled = false;
                this.props.treatmentPlan.smile_3d = '';
                this.handleInput('', 'smile_3d');
                this.handleInput(null, 'upper_cycle');
                this.handleInput(null, 'lower_cycle');
                this.handleInput(null, 'new_product');
                myoElement.hidden = true;
                smile3DElement.scrollIntoView();
                break;
            case 'select_myo':
                // smile3DElement.hidden = true
                smile3DTextField.disabled = true;
                this.props.treatmentPlan.smile_3d = '~pending upload~';
                this.props.treatmentPlan.myo_oid = null;
                this.props.treatmentPlan.myo_pid = null;
                this.props.treatmentPlan.myo_id = null;
                this.props.treatmentPlan.myo_token = null;
                this.handleInput('~pending upload~', 'smile_3d');
                this.handleInput(null, 'upper_cycle');
                this.handleInput(null, 'lower_cycle');
                this.handleInput(null, 'new_product');
                myoElement.hidden = false;
                myoElement.scrollIntoView();
                break;
        }
    };

    handleInput(val, type) {
        this.props.handleTreatmentData(val, type, '');
    }

    removefile(stateType) {
        console.log(stateType);
        this.props.handleTreatmentData(null, stateType, '');
        //this.props.handleDataPhoto("")
    }

    // 判断是否显示 EXOCAD 上传项，Smile Design 或 upsell 允许时显示。
    isRenderExocadOption() {
        console.log('this.props.upsellOperationData ', this.props.upsellOperationData);
        if (smileDesignProductListArray.includes(this.props.smileDesign.caseType)) {
            return true;
        }
        if (this.props.upsellOperationData?.allowUploadExocad) {
            return this.props.upsellOperationData.allowUploadExocad;
        }
        return false;
    }

    // 判断是否显示常规 PDF/Video 上传项，EXOCAD 显示时隐藏常规项。
    isRenderRegularOption() {
        return !this.isRenderExocadOption();
    }

    // 判断是否显示 Smile Report 上传项，Smile Design 或 upsell 允许时显示。
    isRenderSmilePPTOption() {
        if (smileDesignProductListArray.includes(this.props.smileDesign.caseType)) {
            return true;
        }
        if (this.props.upsellOperationData?.allowUploadSmilePPT) {
            return this.props.upsellOperationData.allowUploadSmilePPT;
        }
        return false;
    }

    render() {
        return (
            <Animated animationIn="fadeIn" isVisible={true}>
                <Grid container spacing={1} className={style.twoColumnImage}>
                    {/* Remarls: Smile Report = Smile Design PPT */}
                    {this.isRenderSmilePPTOption() && (
                        <>
                            <Grid
                                item
                                xs={12}
                                sm={6}
                                style={{
                                    marginBottom:
                                        !this.props.smileDesign.smileDesignProductListArray.includes(
                                            this.props.smileDesign.caseType
                                        ) && 80,
                                }}
                            >
                                <p style={{ display: 'block', width: '100%', marginBottom: '25px' }}>
                                    {this.get('@pages.treatmentapproval.smileReport')}:
                                </p>
                                {this.props.treatmentPlan.smileDesignPPT === null ? (
                                    <DragAndDrop
                                        handleDrop={(uploadedFile) => this.handleDrop(uploadedFile, 'smileDesignPPT')}
                                    >
                                        <div className={style.imageUploadArea}>
                                            <span>{this.get('treatmentPlan.dragAndDrop')}</span>
                                            <div className={style.uploadBtnWrapper}>
                                                <button className={style.uploadBtn}>+</button>
                                                <input
                                                    type="file"
                                                    accept={TREATMENT_PLAN_UPLOAD_ACCEPT.smileDesignPPT}
                                                    onChange={(e) => this.onFileChange(e, 'smileDesignPPT')}
                                                    name="patientImage"
                                                    id="patientImage"
                                                />
                                            </div>
                                        </div>
                                    </DragAndDrop>
                                ) : (
                                    <DragAndDrop
                                        handleDrop={(uploadedFile) => this.handleDrop(uploadedFile, 'smileDesignPPT')}
                                    >
                                        <div class={style.imageUploadArea}>
                                            <button
                                                className={style.remove}
                                                onClick={() => this.removefile('smileDesignPPT')}
                                            >
                                                <DeleteOutlinedIcon />
                                            </button>
                                            {this.props.treatmentPlan.smileDesignPPT_label}
                                        </div>
                                    </DragAndDrop>
                                )}
                                <p style={{ textAlign: 'center', color: 'rgba(0,0,0,0.3)' }}>
                                    ({this.get('@pages.treatmentapproval.smileReport')})
                                </p>
                            </Grid>
                            <Grid item xs={12} sm={6}></Grid>
                        </>
                    )}

                    {/* Prepare EXOCAD_file */}
                    {this.isRenderExocadOption() && (
                        <Grid
                            item
                            xs={12}
                            sm={6}
                            style={{
                                marginBottom:
                                    !this.props.smileDesign.smileDesignProductListArray.includes(
                                        this.props.smileDesign.caseType
                                    ) && 80,
                            }}
                        >
                            <div
                                dangerouslySetInnerHTML={{ __html: this.get('@PatientInfo.smileDesign.exocadPre') }}
                                style={{ display: 'block', width: '100%', marginBottom: '16px' }}
                            />
                            {this.props.treatmentPlan.smileDesign_exocad_pre === null ? (
                                <DragAndDrop
                                    handleDrop={(uploadedFile) =>
                                        this.handleDrop(uploadedFile, 'smileDesign_exocad_pre')
                                    }
                                >
                                    <div className={style.imageUploadArea}>
                                        <span>{this.get('treatmentPlan.dragAndDrop')}</span>
                                        <div className={style.uploadBtnWrapper}>
                                            <button className={style.uploadBtn}>+</button>
                                            <input
                                                type="file"
                                                accept={TREATMENT_PLAN_UPLOAD_ACCEPT.smileDesign_exocad_pre}
                                                onChange={(e) => this.onFileChange(e, 'smileDesign_exocad_pre')}
                                                name="smileDesign_exocad_pre"
                                                id="smileDesign_exocad_pre"
                                            />
                                        </div>
                                    </div>
                                </DragAndDrop>
                            ) : (
                                <DragAndDrop
                                    handleDrop={(uploadedFile) =>
                                        this.handleDrop(uploadedFile, 'smileDesign_exocad_pre')
                                    }
                                >
                                    <div class={style.imageUploadArea}>
                                        <button
                                            className={style.remove}
                                            onClick={() => this.removefile('smileDesign_exocad_pre')}
                                        >
                                            <DeleteOutlinedIcon />
                                        </button>
                                        {this.props.treatmentPlan.smileDesign_exocad_pre_label}
                                    </div>
                                </DragAndDrop>
                            )}
                            <p style={{ textAlign: 'center', color: 'rgba(0,0,0,0.3)' }}>
                                ({this.get('@PatientInfo.smileDesign.exocadPre')})
                            </p>
                        </Grid>
                    )}

                    {this.isRenderRegularOption() && (
                        <>
                            <p style={{ display: 'block', width: '100%', marginBottom: '25px' }}>
                                {this.get('treatmentPlan.pdfFile')}:
                            </p>
                            <Grid item xs={12} sm={6}>
                                {this.props.treatmentPlan.pdf1 === null ? (
                                    <DragAndDrop handleDrop={(uploadedFile) => this.handleDrop(uploadedFile, 'pdf1')}>
                                        <div className={style.imageUploadArea}>
                                            <span>{this.get('treatmentPlan.dragAndDrop')}</span>
                                            <div className={style.uploadBtnWrapper}>
                                                <button className={style.uploadBtn}>+</button>
                                                <input
                                                    type="file"
                                                    onChange={(e) => this.onFileChange(e, 'pdf1')}
                                                    name="patientImage"
                                                    id="patientImage"
                                                />
                                            </div>
                                        </div>
                                    </DragAndDrop>
                                ) : (
                                    <DragAndDrop handleDrop={(uploadedFile) => this.handleDrop(uploadedFile, 'pdf1')}>
                                        <div class={style.imageUploadArea}>
                                            <button className={style.remove} onClick={() => this.removefile('pdf1')}>
                                                <DeleteOutlinedIcon />
                                            </button>
                                            {this.props.treatmentPlan.pdf1_label}
                                        </div>
                                    </DragAndDrop>
                                )}
                                <p style={{ textAlign: 'center', color: 'rgba(0,0,0,0.3)' }}>
                                    ({this.get('treatmentPlan.analysis')})
                                </p>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                {this.props.treatmentPlan.pdf2 === null ? (
                                    <DragAndDrop handleDrop={(uploadedFile) => this.handleDrop(uploadedFile, 'pdf2')}>
                                        <div className={style.imageUploadArea}>
                                            <span>{this.get('treatmentPlan.dragAndDrop')}</span>
                                            <div className={style.uploadBtnWrapper}>
                                                <button className={style.uploadBtn}>+</button>
                                                <input
                                                    type="file"
                                                    onChange={(e) => this.onFileChange(e, 'pdf2')}
                                                    name="patientImage"
                                                    id="patientImage"
                                                />
                                            </div>
                                        </div>
                                    </DragAndDrop>
                                ) : (
                                    <DragAndDrop handleDrop={(uploadedFile) => this.handleDrop(uploadedFile, 'pdf2')}>
                                        <div class={style.imageUploadArea}>
                                            <button className={style.remove} onClick={() => this.removefile('pdf2')}>
                                                <DeleteOutlinedIcon />
                                            </button>
                                            {this.props.treatmentPlan.pdf2_label}
                                        </div>
                                    </DragAndDrop>
                                )}
                                <p style={{ textAlign: 'center', color: 'rgba(0,0,0,0.3)' }}>
                                    ({this.get('treatmentPlan.treatmentPlan')})
                                </p>
                            </Grid>
                            <p style={{ display: 'block', width: '100%', marginBottom: '25px' }}>
                                {this.get('treatmentPlan.videoFile')}:
                            </p>
                            <Grid item xs={12} sm={6}>
                                {this.props.treatmentPlan.video1 === null ? (
                                    <DragAndDrop handleDrop={(uploadedFile) => this.handleDrop(uploadedFile, 'video1')}>
                                        <div className={style.imageUploadArea}>
                                            <span>{this.get('treatmentPlan.dragAndDrop')}</span>
                                            <div className={style.uploadBtnWrapper}>
                                                <button className={style.uploadBtn}>+</button>
                                                <input
                                                    type="file"
                                                    onChange={(e) => this.onFileChange(e, 'video1')}
                                                    name="patientImage"
                                                    id="patientImage"
                                                />
                                            </div>
                                        </div>
                                    </DragAndDrop>
                                ) : (
                                    <DragAndDrop handleDrop={(uploadedFile) => this.handleDrop(uploadedFile, 'video1')}>
                                        <div class={style.imageUploadArea}>
                                            <button className={style.remove} onClick={() => this.removefile('video1')}>
                                                <DeleteOutlinedIcon />
                                            </button>
                                            {this.props.treatmentPlan.video1_label}
                                        </div>
                                    </DragAndDrop>
                                )}
                                <p style={{ textAlign: 'center', color: 'rgba(0,0,0,0.3)' }}>
                                    ({this.get('treatmentPlan.buccalViewVideo')})
                                </p>
                            </Grid>

                            <Grid item xs={12} sm={6}>
                                {this.props.treatmentPlan.video2 === null ? (
                                    <DragAndDrop handleDrop={(uploadedFile) => this.handleDrop(uploadedFile, 'video2')}>
                                        <div className={style.imageUploadArea}>
                                            <span>{this.get('treatmentPlan.dragAndDrop')}</span>
                                            <div className={style.uploadBtnWrapper}>
                                                <button className={style.uploadBtn}>+</button>
                                                <input
                                                    type="file"
                                                    onChange={(e) => this.onFileChange(e, 'video2')}
                                                    name="patientImage"
                                                    id="patientImage"
                                                />
                                            </div>
                                        </div>
                                    </DragAndDrop>
                                ) : (
                                    <DragAndDrop handleDrop={(uploadedFile) => this.handleDrop(uploadedFile, 'video2')}>
                                        <div class={style.imageUploadArea}>
                                            <button className={style.remove} onClick={() => this.removefile('video2')}>
                                                <DeleteOutlinedIcon />
                                            </button>
                                            {this.props.treatmentPlan.video2_label}
                                        </div>
                                    </DragAndDrop>
                                )}
                                <p style={{ textAlign: 'center', color: 'rgba(0,0,0,0.3)' }}>
                                    ({this.get('treatmentPlan.occlusalVideo')})
                                </p>
                            </Grid>

                            <Grid item xs={12} sm={12}>
                                <p>Select smile 3D view file upload method</p>
                                <div>
                                    <input
                                        type="radio"
                                        id="url"
                                        name="select_upload_method"
                                        value="select_url"
                                        onChange={(event) => this.handleRadioButtonChange(event.target.value)}
                                    />
                                    <label htmlFor="url">url</label>
                                </div>
                                <div>
                                    <input
                                        type="radio"
                                        id=".myo"
                                        name="select_upload_method"
                                        value="select_myo"
                                        defaultChecked
                                        onChange={(event) => this.handleRadioButtonChange(event.target.value)}
                                    />
                                    <label htmlFor=".myo">.myo/.myp</label>
                                </div>
                            </Grid>

                            <Grid item xs={12} sm={6} id="myo_grid" hidden={false}>
                                {this.props.treatmentPlan.myo_pid == null ? (
                                    <DragAndDrop handleDrop={(uploadedFile) => this.handleMyo(uploadedFile)}>
                                        <div className={style.imageUploadArea}>
                                            {this.state.loadingMyo ? (
                                                <ModalLoader
                                                    height={200}
                                                    hideLogo={true}
                                                    loadingMessage={'Processing, please wait...'}
                                                />
                                            ) : (
                                                <span>{this.get('treatmentPlan.dragAndDrop')}</span>
                                            )}
                                            <div className={style.uploadBtnWrapper}>
                                                <button className={style.uploadBtn}>+</button>
                                                <input
                                                    type="file"
                                                    onChange={(e) => this.onMyoFileChange(e)}
                                                    name="patientImage"
                                                    id="patientImage"
                                                />
                                            </div>
                                        </div>
                                    </DragAndDrop>
                                ) : (
                                    <DragAndDrop handleDrop={(uploadedFile) => this.handleMyo(uploadedFile)}>
                                        <div className={style.imageUploadArea}>
                                            <button
                                                className={style.remove}
                                                onClick={() => {
                                                    this.props.treatmentPlan.myo_oid = null;
                                                    this.props.treatmentPlan.myo_pid = null;
                                                    this.props.treatmentPlan.myo_id = null;
                                                    this.props.treatmentPlan.myo_token = null;
                                                    this.props.treatmentPlan.smile_3d = '~pending upload~';
                                                    this.handleInput('~pending upload~', 'smile_3d');
                                                    this.handleInput(null, 'upper_cycle');
                                                    this.handleInput(null, 'lower_cycle');
                                                    this.handleInput(null, 'new_product');
                                                }}
                                            >
                                                <DeleteOutlinedIcon />
                                            </button>
                                        </div>
                                    </DragAndDrop>
                                )}
                                <p style={{ textAlign: 'center', color: 'rgba(0,0,0,0.3)' }}>
                                    ({this.get('treatmentPlan.myoFile')})
                                </p>
                            </Grid>

                            <Grid item xs={12} sm={12} id="Smile_3D_Grid">
                                <TextField
                                    disabled={true}
                                    style={{ width: '80%' }}
                                    InputProps={
                                        !this.props.treatmentPlan.myo_token
                                            ? { style: { color: 'black' } }
                                            : { style: { color: 'black', fontWeight: 'bold' } }
                                    }
                                    id="3durl"
                                    label="Smile 3D View(Url)"
                                    value={this.props.treatmentPlan.smile_3d}
                                    onChange={(event) => this.handleInput(event.target.value, 'smile_3d')}
                                    onClick={() => {
                                        if (this.props.treatmentPlan.smile_3d.length > 0) {
                                            window.open(this.props.treatmentPlan.smile_3d);
                                        }
                                    }}
                                    margin="normal"
                                />
                            </Grid>
                        </>
                    )}
                </Grid>
            </Animated>
        );
    }
}

const mapStateToProps = (store) => {
    return {
        lang: store.lang,
        smileDesign: store.smileDesign,
    };
};

export default connect(mapStateToProps)(withLang(TreatmentPlan, 'PatientInfo'));
